import React, { PropsWithChildren, useEffect } from 'react';

import { sendGtagPageView } from 'utils/gtag-event';

import useStyles from './styles';

import Footer from '../../../../components/Footer';
import Header from '../../../../components/Header';
import { useIsScrolled } from '../../../../hooks/use-is-scrolled';

interface Props {
    className?: string;
}

const Layout: React.FC<PropsWithChildren<Props>> = ({ children, className }) => {
    const { classes, cx } = useStyles();

    const [isScrolled, scrollerRef] = useIsScrolled();

    useEffect(() => sendGtagPageView(), []);

    return (
        <div className={cx(classes.root, className)} ref={scrollerRef}>
            <div className={classes.leftBg} />
            <div className={classes.rightBg} />
            <div className={classes.noise} />
            <div className={classes.content}>
                <Header className={classes.header} blurry={isScrolled} />
                {children}
                <Footer />
            </div>
        </div>
    );
};

export default Layout;
